import ImagePreviewBar from './ImagePreviewBar';

interface Props {
    fileName: string;
    visible: boolean;
}

const ImagePreviewBottomBar = ({ fileName, visible }: Props) => (
    <ImagePreviewBar visible={visible}>
        <div className="flex h-13 items-center justify-center">
            <p className="text-xs text-white">{fileName}</p>
        </div>
    </ImagePreviewBar>
);

export default ImagePreviewBottomBar;
